import { PatientsTableColumn } from './enums';

export const PatientsTableColumns = [
  {
    column: PatientsTableColumn.NAME,
    minWidth: 20,
  },
  {
    column: PatientsTableColumn.BIRTHDAY,
    minWidth: 15,
  },
  {
    column: PatientsTableColumn.ORGANIZATION,
    minWidth: 25,
  },
  {
    column: PatientsTableColumn.SYNC_STATE,
    minWidth: 25,
  },
  {
    column: PatientsTableColumn.BP_TYPE,
    minWidth: 15,
  },
];
